import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Api from '../api/api';
import Enums from '../../utilities/enum';
import StringHelpers from '../../utilities/stringHelpers';
import UploadFiles from '../shared/file-uploader';
import Loader from '../shared/loader';
import { toDateString, toDateTimeString, toInputFieldDateString } from '../../utilities/dateUtilities';
import arrayUtilities from '../../utilities/arrayUtilities';
import { countries } from '../../utilities/constants';
import { SearchSelect } from '../shared/searchSelect';
import { ErrorModal } from '../../utilities/errorModal';
import { AttachmentsDisplay } from '../shared/attachmentsDisplay';

function Appeal(props) {
    const appealId = props.match.params.appealId;
    const [appeal, setAppeal] = useState(null);
    const [isNew, setIsNew] = useState(false);
    const breachId = props.match.params.breachId;
    const [breach, setBreach] = useState(null);
    const [canAppeal, setCanAppeal] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [files, setFiles] = useState([]);
    const appealResponseBaseUrl = `/organisation/${props.organisationId}/breach/${breachId}/appeal/${appealId}`
    //appeal info
    const [newContactMode, setNewContactMode] = useState(false)
    const [contacts, setContacts] = useState(null)
    const [selectedContact, setSelectedContact] = useState(null)
    const [title, setTitle] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [address3, setAddress3] = useState("");
    const [city, setCity] = useState("");
    const [postcode, setPostcode] = useState("");
    const [country, setCountry] = useState("United Kingdom");
    const [contactNumber, setContactNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [appealReason, setAppealReason] = useState("");
    const [appealFileList, setAppealFileList] = useState([]);
    const [contactTypes, setContactTypes] = useState(null);
    const [appellantType, setAppellantType] = useState(null);
    const [dateReceived, setDateReceived] = useState("");
    const [attachments, setAttachments] = useState(null);
    const [attachmentsDefaultTab, setAttachmentsDefaultTab] = useState("images");
    const attachmentsLayoutKey = `${ props.user.id }-appealAttachmentLayoutPreference`;
    const [attachmentsLayout, setAttachmentsLayout] = useState(localStorage.getItem(attachmentsLayoutKey) ?? 'grid');

    const history = useHistory();

    const getAppeal = function () {
        Api.getAppeal(
            (data) => {
                setAppeal(data);
                setAttachments(data.attachments)
                setIsLoading(false);
            },
            (error) => setErrorMessage(error),
            breachId, appealId,
            props.organisationId,
            props.token
        )
    };

    const removeFileUpload = function (index) {
        var i = 0;
        var j = 0;
        var currentFileIds = [];
        appealFileList.forEach(id => {
            if (i !== index) {
                currentFileIds.push(id);
            }
            i++;
        });

        var currentFiles = [];
        files.forEach(file => {
            if (j !== index) {
                currentFiles.push(file);
            }
            j++;
        });
        setAppealFileList(currentFileIds);
        setFiles(currentFiles);
    };

    const newFileUpload = function (file) {
        var currentFileIds = [];
        appealFileList.forEach(id => {
            currentFileIds.push(id);
        });
        var currentFiles = [];
        files.forEach(file => {
            currentFiles.push(file);
        });
        currentFiles.push(file);
        currentFileIds.push(file.id);

        setFiles(currentFiles);
        setAppealFileList(currentFileIds);
    };

    const getContacts = function () {
        Api.getAllContacts(
            (data) => {                
                if (arrayUtilities.isNullOrEmpty(data)) {
                    setNewContactMode(true)
                } else {
                    setContacts(data)
                }
            },
            (error) => { console.log(error) },
            breachId, props.organisationId, props.token
        )
    };

    const handleContactSelection = (contactId) => {
        setNewContactMode(false)
        setSelectedContact(contactId)
    }

    const resetContactFields = () => {
        setAppellantType(null)
        setTitle("")
        setFirstName("")
        setLastName("")
        setCompanyName("")
        setAddress1("")
        setAddress2("")
        setAddress3("")
        setCity("")
        setPostcode("")
        setCountry("United Kingdom")
        setContactNumber("")
        setEmailAddress("")
    }

    const getBreach = function () {
        Api.getBreach(
            (data) => setBreach(data),
            (error) => setErrorMessage(error),
            breachId,
            props.organisationId,
            props.token
        )
    };


    const submit = function () {
        if (canAppeal) {
            setIsLoading(true)
            let details = { 
                firstName: null, 
                lastName: null, 
                addressLine1: null, 
                addressLine2: null, 
                addressLine3: null, 
                townOrCity: null, 
                postCode: null, 
                country: null, 
                mobilePhoneNumber: null, 
                emailAddress: null, 
                contactType: null, 
                companyName: null, 
                contactId: null 
            };
            if (StringHelpers.isNullOrEmpty(selectedContact)) {
                details = { ...details, firstName, lastName, addressLine1: address1, addressLine2: address2, addressLine3: address3, townOrCity: city, postCode: postcode, country, mobilePhoneNumber: contactNumber, emailAddress, contactType: appellantType, companyName };
            } else {
                details = { ...details, contactId: selectedContact };
            }

            Api.addAppeal(
                (data) => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage)
                    } else {
                        history.push(`/organisation/${props.organisationId}/breach/${breachId}/appeal/${data.id}`)
                    }
                    setIsLoading(false)
                },
                (error) => {
                    setErrorMessage(error.errorMessage)
                    setIsLoading(false)
                },
                details, appealReason, appealFileList, !StringHelpers.isNullOrEmpty(dateReceived) ? dateReceived : null, breachId, props.organisationId, props.token,
            );
        }
    };

    const setTypes = function (types) {
        var tempTypes = [];
        var i = 0;
        while (true) {
            if (types[i] === undefined) {
                break;
            } else {
                tempTypes.push(types[i])
                i++;
            }
        }
        setContactTypes(tempTypes);
    };

    useEffect(() => {
        const contactValid = !StringHelpers.isNullOrEmpty(selectedContact) ||
            (appellantType !== null && !StringHelpers.isNullOrEmpty(firstName) && !StringHelpers.isNullOrEmpty(lastName) &&
            !StringHelpers.isNullOrEmpty(address1) && !StringHelpers.isNullOrEmpty(city) &&
            !StringHelpers.isNullOrEmpty(postcode) && !StringHelpers.isNullOrEmpty(emailAddress));
        setCanAppeal(contactValid && !StringHelpers.isNullOrEmpty(appealReason));
    }, [selectedContact, appellantType, firstName, lastName, address1, city, postcode, emailAddress, appealReason, appealFileList]);

    useEffect(() => {
        if (breachId !== null) {
            getBreach();
            getContacts()
            if (!StringHelpers.isNullOrEmpty(appealId)) {
                getAppeal();
            } else {
                setIsNew(true);
                setIsLoading(false);
                setTypes(Enums.ContactTypes);
            }
        };
    }, [appealId]);

    var backUrl = '/organisation/' + props.organisationId + '/breach/' + breachId;
    
    return (
        <>
            {isLoading && <Loader />}
            {!isLoading && appeal !== null && breach !== null &&
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">Appeal - {breach.referenceNumber}</h5>
                                        </div>
                                        <Link className="btn btn-falcon-default btn-sm mr-3 py-1" type="button" to={backUrl}><i className="fas fa-reply"></i> Back</Link>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-3">Status</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{Enums.AppealStatus[appeal.appealStatus]}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-3">Reason</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{appeal.appealReason}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-3">Time Stamp</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{toDateTimeString(appeal.timestamp)}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-3">First Name</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{appeal.contactDetails.firstName}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-3">Last Name</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{appeal.contactDetails.lastName}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-3">Company Name</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{appeal.contactDetails.companyName}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-3">Email Address</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{appeal.contactDetails.emailAddress}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-3">Contact Number</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{appeal.contactDetails.mobilePhoneNumber}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-3">Contact Type</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">
                                            {Enums.ContactTypes[appeal.contactDetails.contactType]}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-3">Contact Source</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">
                                            {Enums.ContactSource[appeal.contactDetails.contactSource]}
                                        </div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col-12 col-md-3">
                                            <p className="font-weight-semi-bold mb-3">Address</p>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            {appeal.contactDetails.addressLine1 && <>{appeal.contactDetails.addressLine1}<br /></>}
                                            {appeal.contactDetails.addressLine2 && <>{appeal.contactDetails.addressLine2}<br /></>}
                                            {appeal.contactDetails.addressLine3 && <>{appeal.contactDetails.addressLine3}<br /></>}
                                            {appeal.contactDetails.townOrCity && <>{appeal.contactDetails.townOrCity}<br /></>}
                                            {appeal.contactDetails.county && <>{appeal.contactDetails.county}<br /></>}
                                            {appeal.contactDetails.postCode && <>{appeal.contactDetails.postCode}<br /></>}
                                            {appeal.contactDetails.country && <>{appeal.contactDetails.country}<br /></>}
                                        </div>
                                    </div>
                                    <hr className="border-dashed border-bottom-0"></hr>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-3">Date Received</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">
                                            {toDateString(appeal.timestamp)}
                                        </div>
                                    </div>
                                    <div className="row align-items-start">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-0">Appeal Attachments</p>
                                        </div>
                                        <div className="col-md-7 col-12 ">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <ul className="nav nav-tabs w-100" id="appealAttachmentsTabbed" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button className={ `nav-link ${ attachmentsDefaultTab === "images" ? "active" : "" }` } id="appeal-images-tab" data-toggle="tab" data-target="#appeal-images" type="button" role="tab" aria-controls="appeal-images" aria-selected={ attachmentsDefaultTab === "images" }>
                                                            <i className='far fa-file-image mr-2'></i>
                                                            Images
                                                            <span className={ `ml-2 badge badge-${ attachments?.filter(attachment => attachment.isImage).length === 0 ? "secondary" : "success" }` }>{ attachments?.filter(attachment => attachment.isImage).length }</span>
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className={ `nav-link ${ attachmentsDefaultTab === "files" ? "active" : "" }` } id="appeal-files-tab" data-toggle="tab" data-target="#appeal-files" type="button" role="tab" aria-controls="appeal-files" aria-selected={ attachmentsDefaultTab === "files" }>
                                                            <i className='far fa-list-alt mr-2'></i>
                                                            Documents
                                                            <span className={ `ml-2 badge badge-${ attachments?.filter(attachment => !attachment.isImage).length === 0 ? "secondary" : "success" }` }>{ attachments?.filter(attachment => !attachment.isImage).length }</span>
                                                        </button>
                                                    </li>
                                                </ul>
                                                <div className="btn-group">
                                                    <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" data-display="static">
                                                        { attachmentsLayout === 'grid'
                                                            ? <><i className='fas fa-border-all mr-2'></i>Grid</>
                                                            : <><i className='far fa-list-alt mr-2'></i>List</>
                                                        }
                                                    </button>
                                                    <div className="dropdown-menu dropdown-menu-right p-0">
                                                        <button onClick={ () => { setAttachmentsLayout('grid'); localStorage.setItem(attachmentsLayoutKey, 'grid'); } } className="dropdown-item p-2 w-fit">
                                                            <i className='fas fa-border-all mr-2'></i>Grid
                                                        </button>
                                                        <button onClick={ () => { setAttachmentsLayout('list'); localStorage.setItem(attachmentsLayoutKey, 'list'); } } className="dropdown-item p-2 w-fit">
                                                            <i className='far fa-list-alt mr-2'></i>List
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-content" id="appealAttachmentsTabbedContent">
                                                <div className={ `tab-pane fade p-2 bg-white ${ attachmentsDefaultTab === "images" ? "show active" : "" }` } id="appeal-images" role="tabpanel" aria-labelledby="appeal-images-tab">
                                                    <AttachmentsDisplay
                                                        attachments={ !arrayUtilities.isNullOrEmpty(attachments) ? attachments : [] }
                                                        type="images"
                                                        viewLayout={ attachmentsLayout }
                                                        canUpdate={ false }
                                                    />
                                                </div>
                                                <div className={ `tab-pane fade p-2 bg-white ${ attachmentsDefaultTab === "files" ? "show active" : "" }` } id="appeal-files" role="tabpanel" aria-labelledby="appeal-files-tab">
                                                    <AttachmentsDisplay
                                                        attachments={ !arrayUtilities.isNullOrEmpty(attachments) ? attachments : [] }
                                                        type="documents"
                                                        viewLayout={ attachmentsLayout }
                                                        canUpdate={ false }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    appeal.appealStatus === 0 && <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-danger btn-sm ml-2" onClick={ () => history.push(`${ appealResponseBaseUrl }/decline`) }>
                                                        <i className="fas fa-times mr-2"></i>Decline</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" onClick={ () => history.push(`${ appealResponseBaseUrl }/accept`) }>
                                                        <i className="fas fa-check mr-2"></i>Accept</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>}
            {!isLoading && isNew && <>
                <div className="card my-3">
                    <div className="card-header themed-title">
                        <div className="row align-items-center justify-space-between">
                            <div className="col">
                                <h4 className="mb-0 ">
                                    Create Appeal
                                </h4>
                            </div>
                            <Link className="btn btn-falcon-default btn-sm mr-3 py-1" type="button" to={backUrl}><i className="fas fa-reply"></i> Back</Link>
                        </div>
                    </div>
                    <div className="card-body bg-light border-top">
                        <div className="row">
                            <div className="col-12">
                                <p className="font-weight-bold mb-3">Appellant Details</p>
                            </div>
                        </div>
                        {
                            !arrayUtilities.isNullOrEmpty(contacts) && 
                            <div className="row mb-3">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold mb-1">Contact</p>
                                </div>
                                <div className="col-md-6 col-12">
                                    {
                                        contacts.map(
                                            contact => <div className='form-check mb-2'>
                                                <input class="form-check-input my-0" type="radio" name="contact-list-selection" id={ contact.id } checked={ selectedContact === contact.id } onClick={ () => handleContactSelection(contact.id) } />
                                                <label className={`form-check-label ml-3 mb-0${contact.isActive ? " font-weight-bold" : ""}`} htmlFor={ contact.id }>
                                                    {StringHelpers.contactDetailsName(contact)} {contact.isActive && <>(Active)</>}
                                                </label>
                                            </div>
                                        )
                                    }
                                    <div className='form-check mb-2'>
                                        <input class="form-check-input my-0" type="radio" name="contact-list-selection" id="manual-entry-selection" checked={ newContactMode } onClick={ () => {
                                            setNewContactMode(true)
                                            setSelectedContact(null)
                                            resetContactFields()
                                        } } />
                                        <label class="form-check-label ml-3 mb-0" htmlFor="manual-entry-selection">
                                            Create a new contact<i className='ml-1 fas fa-plus text-success'></i>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                        newContactMode && 
                            <>
                                <div className="row">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold mb-1">Liable Party Designation<span className="req"></span></p>
                                    </div>
                                    <div className="col-md-6 col-12 ">
                                        {contactTypes !== null && contactTypes.map((item, i = 0) => {
                                            i++;
                                            var text = `When the contravention occurred I was the vehicle's ` + item;
                                            var checked = false;
                                            if (appellantType === i - 1) {
                                                checked = true;
                                            }
                                            return (
                                                <div class="form-check mb-2">
                                                    <input class="form-check-input my-0" type="radio" name="flexRadioDefault" id={i} checked={checked} onClick={() => setAppellantType(i - 1)} />
                                                    <label class="form-check-label ml-3 mb-0" for={i}>
                                                        {text}
                                                    </label>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold mb-1">Title<span className="req"></span></p>
                                    </div>
                                    <div className="col-md-6 col-12 ">
                                        <div className="form-group mb-0">
                                            <div className="dropdown">
                                                <button className="btn btn-falcon-default dropdown-toggle btn-sm mb-1 edit-dropdown" id="select-title" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{title !== "" && <>{title}</>}{title === "" && <>Select Title</>}</button>
                                                <div className="dropdown-menu py-0 edit-dropdown" aria-labelledby="select-title" >
                                                    <div className="bg-white py-2 rounded-soft">
                                                        <button className="dropdown-item text-base px-3 py-2" onClick={() => setTitle("Mr")}>Mr</button>
                                                        <button className="dropdown-item text-base px-3 py-2" onClick={() => setTitle("Mrs")}>Mrs</button>
                                                        <button className="dropdown-item text-base px-3 py-2" onClick={() => setTitle("Miss")}>Miss</button>
                                                        <button className="dropdown-item text-base px-3 py-2" onClick={() => setTitle("Ms")}>Ms</button>
                                                        <button className="dropdown-item text-base px-3 py-2" onClick={() => setTitle("Dr")}>Dr</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">First Name<span className="req"></span></p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Last Name<span className="req"></span></p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Company Name</p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Address Line 1<span className="req"></span></p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={address1} onChange={(e) => setAddress1(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Address Line 2</p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={address2} onChange={(e) => setAddress2(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Address Line 3</p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={address3} onChange={(e) => setAddress3(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">City<span className="req"></span></p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={city} onChange={(e) => setCity(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Postcode<span className="req"></span></p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={postcode} onChange={(e) => setPostcode(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-1">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold mb-1">Country</p>
                                    </div>
                                    <div className="col-md-6 col-12 ">
                                        <div className="form-group mb-0">
                                            <SearchSelect
                                                width="100%"
                                                options={ countries.map(item => ({ value: item.name, label: item.name })) }
                                                onSelect={ value => setCountry(value) }
                                                selected={ country }
                                                defaultLabel="Select country"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Contact Number</p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={contactNumber} onChange={(e) => setContactNumber(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Email Address<span className="req"></span></p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        <hr className="border-dashed border-bottom-0"></hr>
                        <div className="row">
                            <div className="col-12">
                                <h4>Your Reason for appealing the Charge Notice</h4>
                                <p className="font-weight-semi-bold mb-3">Please complete the following screen, outlining the reason for your appeal. Please provide as much information as possible that will help our team to
                                    investigate the matter and attach any evidence you may have that supports your case. When supplying attachments we accept photographs in JPEG format and will accept documents in either scanned pdf format
                                    or word documents. We cannot accept zip files.</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">Appeal Reason<span className="req"></span></p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group mb-1">
                                    <textarea rows={8} className="form-control mb-0" type="text" value={appealReason} onChange={(e) => setAppealReason(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-center">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">Supporting Documents<span className="req"></span></p>
                            </div>
                            {files.length !== 0 &&
                                <div className="col-12 col-md-6">
                                    {files.map((file, i = 0) => {
                                        i++;
                                        return (
                                            <div className="row align-items-center">
                                                <div className="col-4">
                                                    <a href={file.url} target="_blank"><h6 className="m">{file.filename}</h6></a>
                                                </div>
                                                <div className="col-5">
                                                    {file.isImage &&
                                                        <div className="d-flex justify-content-center my-2">
                                                            <img src={file.url} className="attachment-thumb" />
                                                        </div>}
                                                    {!file.isImage && <>
                                                        {file.contentType === "application/pdf" && <div className="d-flex justify-content-center my-2"><i className="far fa-6x fa-file-pdf"></i></div>}
                                                        {file.contentType === "application/word.doc" && <div className="d-flex justify-content-center my-2"><i className="far fa-file-word"></i></div>}
                                                        {file.contentType !== "application/word.doc" && file.contentType !== "application/pdf" && <div className="d-flex justify-content-center my-2"><i className="far fa-file-alt"></i></div>}
                                                    </>}
                                                </div>
                                                <div className="col-3">
                                                    <button className="btn btn-sm btn-danger" onClick={() => removeFileUpload(i - 1)}>Remove</button>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>}
                            <div className="col-auto">
                                <button className="btn btn-falcon-default my-3" data-toggle="modal" data-target="#add-new-photos">Add Supporting Documents</button>
                            </div>
                        </div>
                        <div className="modal fade save-dialog success-dialog" id="add-new-photos" tabIndex="-1" role="dialog">
                            <UploadFiles onSuccess={(file) => newFileUpload(file)} type="Documents" organisationId={props.organisationId} />
                        </div>
                        <hr className="border-dashed border-bottom-0"></hr>
                        <div className="row mb-3">
                            <div className="col-md-3 col-12 ">
                                <p className="font-weight-semi-bold  mt-1 mb-1">Date Received</p>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="form-group mb-0">
                                    <input className="form-control mb-1" type="date" value={ toInputFieldDateString(dateReceived) } onChange={ (e) => setDateReceived(e.target.value) } />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer border-top">
                        <div className="row client-edit-buttons">
                            <div className="col-6 col-sm-auto ml-auto  pl-0">
                                <div id="dashboard-actions">
                                    <Link className="btn btn-falcon-default btn-sm" to={backUrl}><i className="fas fa-times"></i> Cancel</Link>
                                    <button type="button" className="btn btn-success btn-sm ml-2" disabled={!canAppeal} onClick={() => submit()}>
                                        <i className="fas fa-check"></i> Confirm</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>}
            {!StringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal message={errorMessage} onHide={() => setErrorMessage(null)} />}
        </>
    )
}
export default Appeal;